import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_SESSION_PORT } from '../ports/auth-session.port';

export const authGuard: CanActivateFn = () => {
  const session = inject(AUTH_SESSION_PORT);
  const router = inject(Router);

  if (session.isAuthenticated()) {
    return true;
  }

  session.logout().subscribe();
  return router.createUrlTree(['/auth/login']);
};
